/**
 * SCIM operations page — URL search-param schema.
 *
 * Per CLAUDE.md "URL is the source of truth for list/filter
 * state": no React useState mirroring these. Deep-links to a
 * specific filter / page work because every navigation that
 * mutates filters runs through `navigate({ search })` and the
 * page reads via `useSearch`.
 *
 * Filters today:
 *
 *   offset       — pagination cursor (0 = page 1). Client passes
 *                  this directly to the backend; limit is fixed at
 *                  50 so two operators sharing a deep-link see the
 *                  same row range.
 *   errors_only  — client-side filter: hide rows with status<400.
 *                  This narrows the CURRENT page of 50; it does
 *                  NOT ask the server for the next 50-with-errors.
 *                  A server-side filter would require a backend
 *                  query parameter that doesn't exist today.
 *
 * Future filters that would warrant backend support:
 *   - resource search (q)
 *   - operation-type filter
 *   - date range
 */

import { z } from "zod";

export const SCIM_OPS_LIST_LIMIT = 50;

export const scimOpsListSearchSchema = z.object({
  offset: z.coerce.number().int().nonnegative().optional(),
  errors_only: z.coerce.boolean().optional(),
});
export type ScimOpsListSearch = z.infer<typeof scimOpsListSearchSchema>;
